// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Example: HORIZONTAL

export const TextOrientationSchema = t.keyof({
  HORIZONTAL: null,
  VERTICAL: null,
});

export type TextOrientation = t.TypeOf<typeof TextOrientationSchema>;
